import React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import PrivateRouteLayout from "./screens/layout/PrivateRouteLayout";
import PublicRouteLayout from "./screens/layout/publicRouteLayout/PublicRouteLayout";
import PublicAuthRouteLayout from "./screens/layout/publicAuthRouteLayout/PublicAuthRouteLayout";

// import Register from "./screens/register/Register";
// import ResetPassword from "./screens/resetPassword/ResetPassword";
// import OtpVerification from "./screens/otpVerification/OtpVerification";
// import Welcome from "./screens/welcome/Welcome";
import Login from "./screens/login/Login";
import EventPageComponent from "./screens/eventPage/EventPageComponent";
import OrderForm from "./screens/orderForm/OrderForm";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import PaymentSuccess from "./screens/paymentSuccess/PaymentSuccess";
import MaintenanceScreen from "./screens/maintenance/MaintenanceScreen";
import Orders from "./screens/orders/Orders";
import LeadersBulletin from "./screens/leadersBulletin/LeadersBulletin";
import OrderCheckIn from "./screens/orders/orderCheckIn/OrderCheckIn";

import "./App.scss";

const PublicRoutes = (
  <Route path="/admin" element={<PublicRouteLayout />}>
    <Route path="event/:eventId/extension" element={<EventPageComponent />} />
    <Route path="event/:eventId/order-form" element={<OrderForm />} />
    <Route path="payment-success" element={<PaymentSuccess />} />
    <Route path="event/:eventId/order" element={<Orders />} />
    <Route path="event/:eventId/order/checkIn" element={<OrderCheckIn />} />
    <Route
      path="event/:eventId/leadersBulletin"
      element={<LeadersBulletin />}
    />
    {/* <Route path="register" element={<Register />} /> 
    <Route path="otp" element={<OtpVerification />} />
    <Route path="resetPassword" element={<ResetPassword />} />
    <Route path="unauthorized" element={<Unauthorized />} />
    <Route path="*" element={<Missing />} /> */}
  </Route>
);

const PublicAuthRoutes = (
  <Route path="/" element={<PublicAuthRouteLayout />}>
    <Route index element={<Navigate to="/login" />} />{" "}
    <Route path="login" element={<Login />} />
  </Route>
);

const PrivateRoutes = (
  <Route path="/" element={<PrivateRouteLayout />}>
    {/* <Route path="welcome" element={<Welcome />} /> */}
    {/* <Route path="event" element={<EventPage />} /> */}
    {/* <Route path="hours" element={<BusinessHours />} />
    <Route path="calendar" element={<Calendar />} />
    <Route path="finances" element={<Finances />} />
    <Route path="services" element={<Services />} />
    <Route path="services/new" element={<NewService />} />
    <Route path="marketing" element={<Marketing />} /> */}
  </Route>
);

const isMaintenanceOn = false;

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {isMaintenanceOn ? (
          <Route path="*" element={<MaintenanceScreen />} />
        ) : (
          <>
            {PublicRoutes}
            {PublicAuthRoutes}
            {PrivateRoutes}
          </>
        )}
      </Routes>
    </>
  );
}
